import extractDataFromMap from "../../../utils/ExtractDataFromMap";
import groupCalculation from "./report-template-group-calculation";
import { groupSetting } from "./report-template-setting";

const ReportTemplateReformatData = (listData, page, take) => {
  const resultList = [];
  const groupMap = {};
  const groupNames = [];

  if (groupSetting) {
    for (let i = 0; i < listData.length; i++) {
      const el = listData[i];
      const groupLabel = extractDataFromMap({
        key: groupSetting.field,
        map: el,
      });
      const groupData = extractDataFromMap({
        key: groupSetting.data_field,
        map: el,
      });

      if (groupLabel) {
        if (!groupMap[groupLabel]) {
          groupMap[groupLabel] = {
            group_label: groupLabel,
            group_data: groupData,
            list_data: [el],
          };
          groupNames.push(groupLabel);
        } else {
          groupMap[groupLabel].list_data.push(el);
        }
      }
    }

    // group operations go here
    for (let groupName of groupNames) {
      if (groupName) {
        const group = groupMap[groupName];
        if (group) {
          groupCalculation(group);
        }
      }
    }

    let mykey = 1;
    for (let groupName of groupNames) {
      const group = groupMap[groupName];
      // add group header detail
      group["mykey"] = mykey++;
      group["report_type"] = "group-header";
      resultList.push(group);
      // add detail data
      let no = 1;
      for (let detail of groupMap[groupName].list_data) {
        let _durasi = Math.floor(
          (new Date() - new Date(detail.tanggal)) / (1000 * 60 * 60 * 24)
        );
        detail["no"] = no++;
        detail["mykey"] = mykey++;
        detail["report_type"] = "detail";
        detail["durasi"] = _durasi;
        resultList.push(detail);
      }
      // add group footer detail
      const groupFooter = {
        ...group,
        mykey: mykey++,
        report_type: "group-footer",
      };
      resultList.push(groupFooter);
    }
  } else {
    for (let i = 0; i < listData.length; i++) {
      const el = listData[i];
      let _labelGrup = el.label_grup.replaceAll("_", " ");
      _labelGrup = _labelGrup.charAt(0).toUpperCase() + _labelGrup.slice(1);

      let _durasi = Math.floor(
        (new Date() - new Date(el.tanggal)) / (1000 * 60 * 60 * 24)
      );

      resultList.push({
        ...el,
        mykey: i + 1,
        no: (page - 1) * take + i + 1,
        label_grup: _labelGrup,
        durasi: _durasi,
        report_type: "detail",
      });
    }
  }

  return { list: resultList, groupNames, groupMap };
};

export default ReportTemplateReformatData;
